
import { Link } from "react-router-dom";
import { Facebook, X, Instagram, Linkedin, Youtube, Phone, Mail, Navigation2, ExternalLink } from "lucide-react";

import { faXTwitter, faTelegram, faFacebook, faInstagram, faYoutubeSquare, faLinkedin, faInstagramSquare, faFacebookF, faSquareXTwitter, faLinkedinIn, faYoutube, faTelegramPlane} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  return (
    <footer className="bg-hero-dark text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Navigation */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/strategies" className="hover:text-gray-300 transition-colors">
                  Metrade Verified
                </Link>
              </li>
              <li>
                <Link to="/marketplace" className="hover:text-gray-300 transition-colors">
                  Marketplace
                </Link>
              </li>
              <li>
                <Link to="/knowledge-hub" className="hover:text-gray-300 transition-colors">
                  Knowledge Hub
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="hover:text-gray-300 transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-gray-300 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-gray-300 transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/get-started" className="hover:text-gray-300 transition-colors">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <div className="space-y-2 text-sm">
              <p className="font-medium">AI-BRAINVISUALS AG</p>
              <p className="flex items-start gap-2">
                <Navigation2 className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>St. Luzi-Strasse 43<br />9492 Eschen</span>
              </p>
              <p>Register Nr. FL 0002.643.29-0</p>
              <div className="flex items-center gap-2 mt-4">
                <Mail className="h-4 w-4" />
                <a href="mailto:support@metrade.io" className="hover:text-gray-300 transition-colors">
                  support@metrade.io
                </a>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
            <div className="grid grid-cols-3 gap-4">
              <a 
                href="https://www.instagram.com/metradeapp/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} className="h-5 w-5" />
              </a>
              <a 
                href="https://www.facebook.com/metradeapp" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebookF} className="h-5 w-5" />
                
              </a>
              <a 
                href="https://twitter.com/metradeapp" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors"
                aria-label="X (formerly Twitter)"
              >
                <FontAwesomeIcon icon={faXTwitter} className="h-5 w-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/ai-brainvisuals/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors"
                aria-label="LinkedIn"
              >
                
                <FontAwesomeIcon icon={faLinkedinIn} className="h-5 w-5" />
              </a>
              <a 
                href="https://www.youtube.com/@metrade-app" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors"
                aria-label="YouTube"
              >
                <FontAwesomeIcon icon={faYoutube} className="h-5 w-5" />
              </a>
              <a 
                href="https://t.me/Metradeofficialapp" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-gray-300 transition-colors"
                aria-label="Telegram"
              >
                
                <FontAwesomeIcon icon={faTelegram} className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="hover:text-gray-300 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-gray-300 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="hover:text-gray-300 transition-colors">
                  Risk Disclaimer
                </Link>
              </li>
              <li>
                <a 
                  href="https://partners.metrade.io/login" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center hover:text-gray-300 transition-colors"
                >
                  Partner Login <ExternalLink className="ml-1" size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} AI-BRAINVISUALS AG. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
